<template>
  <div class="navigation" style="  overflow: auto;">
    <ul class="mt-3">
      <li>
        <router-link to="/panel/dashboard" class="title">
          <span class="icon"><i class="fa fa-solar-panel" aria-hidden="true"></i></span>
          <span class="title"><h2> پنل مدیریت </h2></span>
        </router-link>
      </li>
      <li v-if="checkpermissionView.permissionView('categories','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-address-card" aria-hidden="true"></i></span>
          <router-link to="/panel/categories" class="title"> ایجاد و نمایش دسته بندی ها</router-link>
        </a>
      </li>

      <li v-if="checkpermissionView.permissionView('excel' , 'view')">
        <a href="#">
          <span class="icon"><i class="fa fa-file-excel" aria-hidden="true"></i></span>
          <router-link to="/panel/upload/Excel" class="title">اپلود فایل اکسل سوالات</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('listQuestions' , 'view')">
        <a href="#">
          <span class="icon"><i class="fa fa-comments" aria-hidden="true"></i></span>
          <router-link to="/panel/listQuestions" class="title">لیست سوالات ها</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('createQuestions' ,'view')">
        <a href="#">
          <span class="icon"><i class="fa fa-info-circle" aria-hidden="true"></i></span>
          <router-link to="/panel/CreateQuestions/create" class="title">ایجاد سوال های جدید</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('customers' ,'view')">
        <a href="#">
          <span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span>
          <router-link to="/panel/customers" class="title">لیست افرادی شرکت در آزمون</router-link>

        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('users','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-user" aria-hidden="true"></i></span>
          <router-link to="/panel/users" class="title">مدیریت کاربران</router-link>

        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('roles','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-cog" aria-hidden="true"></i></span>
          <router-link to="/panel/roles" class="title">تنظیمات صفحه ها</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('agent','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-eraser " aria-hidden="true"></i></span>
          <router-link to="/panel/agents" class="title">ثبت بسته</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('discount','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-cog" aria-hidden="true"></i></span>
          <router-link to="/panel/discount" class="title">مدیریت کد های تخفیف </router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('reset','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-cog" aria-hidden="true"></i></span>
          <router-link to="/panel/reset" class="title">ریست کردن ازمون</router-link>
        </a>
      </li>
      <li v-if="checkpermissionView.permissionView('transactions','view')">
        <a href="#">
          <span class="icon"><i class="fa fa-cog" aria-hidden="true"></i></span>
          <router-link to="/panel/transactions" class="title">تراکنش ها</router-link>
        </a>
      </li>

      <li>
        <a href="#" @click="logout">
          <span class="icon"><i class="fa fa-sign-out-alt" aria-hidden="true"></i></span>
          <span class="title">خروج از پنل مدیریت</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import * as  checkpermissionView from "@/common/js/checkPermission"

function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('users')
  localStorage.clear();
  window.location.replace('/panel');

}

</script>
